import * as React from "react";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Render `border-destructive ring-destructive` to indicate validation error. */
  error?: boolean;
  /** When `false`, BASE drops `w-full`. Default `true`. */
  block?: boolean;
}

const BASE_NO_WIDTH =
  "rounded-md border border-border bg-card px-3 py-1.5 text-sm text-foreground shadow-sm focus:border-ring focus:outline-none focus:ring-1 focus:ring-ring placeholder:text-muted-foreground disabled:bg-muted disabled:cursor-not-allowed";
const BLOCK = "w-full";
const ERROR_CLASSES = "border-destructive focus:border-destructive focus:ring-destructive";

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ error, block = true, className, ...rest }, ref) {
    const classes = [
      BASE_NO_WIDTH,
      block ? BLOCK : "",
      error ? ERROR_CLASSES : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");
    return <textarea ref={ref} className={classes} {...rest} />;
  },
);
